import options from './app.component';

/**
 * App component settings for further initialization
 */
export default {
    selector: 'dtApp',
    options
};



// WEBPACK FOOTER //
// ./app/app.settings.js